module.exports = __webpack_public_path__ + "static/media/social-x.c019bd43.png";